import { OrderType } from 'types';

export enum PaymentType {
	cash = 'cash',
	transfer = 'transfer',
}

export const getReadablePaymentType = (paymentType: PaymentType): string => {
	switch (paymentType) {
		case PaymentType.cash:
			return 'Gotówka';

		case PaymentType.transfer:
			return 'Przelew';

		default:
			return 'Nieznany';
	}
};

export interface Payment {
	id: number;
	clientId: number;
	orderId: number;
	orderType: OrderType;
	amount: number;
	type: PaymentType;
	date: Date;
	createdAt: Date;
	createdBy: number;
}
